<template>
  <!-- 特殊价格设置 -->
  <el-dialog
    v-model="specialPriceVisible"
    :close-on-click-modal="false"
    title="特殊价格设置"
    width="80%"
    @close="specialPriceClose"
  >
    <div class="h2">
      特殊日期价格
      <el-button
        v-if="specialForm.datePriceList.length <= 0"
        type="primary"
        size="mini"
        @click="addRules('dates')"
      >
        创建
      </el-button>
    </div>
    <template v-if="specialForm.datePriceList.length > 0">
      <el-row :gutter="10">
        <el-col :span="6">开始日期</el-col>
        <el-col :span="6">结束日期</el-col>
        <el-col :span="4">价格</el-col>
        <el-col :span="4">场次</el-col>
        <el-col :span="4">操作</el-col>
      </el-row>
      <el-row
        :gutter="10"
        v-for="(item, index) in specialForm.datePriceList"
        :key="'dates' + index"
      >
        <el-col :span="6">
          <el-date-picker
            style="width: 100%"
            v-model="item.startDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择开始日期"
          ></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            style="width: 100%"
            v-model="item.endDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择结束日期"
          ></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-input-number
            controls-position="right"
            style="width: 100%"
            v-model="item.price"
            :min="0"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <el-select
            style="width: 100%"
            v-model="item.sectionTitle"
            placeholder="请选择场次"
            clearable
          >
            <el-option
              v-for="(section, index) in specialForm.sectionList"
              :key="index"
              :label="section.title"
              :value="section.title"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-circle-plus-outline" @click="addRules('dates')"></i>
          <i
            class="el-icon-remove-outline"
            @click="minusRules(index, 'dates')"
          ></i>
        </el-col>
      </el-row>
    </template>
    <template v-if="specialForm.datePriceList.length <= 0">
      <div class="emptyState">没有已设置的条件</div>
    </template>
    <div class="h2">
      特殊星期价格
      <el-button
        v-if="specialForm.weekPriceList.length <= 0"
        type="primary"
        size="mini"
        @click="addRules('weeks')"
      >
        创建
      </el-button>
    </div>
    <template v-if="specialForm.weekPriceList.length > 0">
      <el-row :gutter="10">
        <el-col :span="4">开始月份</el-col>
        <el-col :span="4">结束月份</el-col>
        <el-col :span="4">星期</el-col>
        <el-col :span="4">场次</el-col>
        <el-col :span="4">价格</el-col>
        <el-col :span="4">操作</el-col>
      </el-row>
      <el-row
        :gutter="10"
        v-for="(item, index) in specialForm.weekPriceList"
        :key="'week' + index"
      >
        <el-col :span="4">
          <el-date-picker
            style="width: 100%"
            v-model="item.startMonth"
            type="month"
            value-format="YYYY-MM"
            placeholder="选择开始月份"
          ></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            style="width: 100%"
            v-model="item.endMonth"
            type="month"
            value-format="YYYY-MM"
            placeholder="选择结束月份"
          ></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-select
            multiple
            style="width: 100%"
            v-model="item.WeekList"
            placeholder="请选择星期"
            clearable
          >
            <el-option
              v-for="(week, val) in weekOptions"
              :key="val"
              :label="week.label"
              :value="week.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            style="width: 100%"
            v-model="item.sectionTitle"
            placeholder="请选择场次"
            clearable
          >
            <el-option
              v-for="(section, index) in specialForm.sectionList"
              :key="index"
              :label="section.title"
              :value="section.title"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input-number
            controls-position="right"
            style="width: 100%"
            v-model="item.price"
            :min="0"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-circle-plus-outline" @click="addRules('weeks')"></i>
          <i
            class="el-icon-remove-outline"
            @click="minusRules(index, 'weeks')"
          ></i>
        </el-col>
      </el-row>
    </template>
    <template v-if="specialForm.weekPriceList.length <= 0">
      <div class="emptyState">没有已设置的条件</div>
    </template>
    <template #footer>
      <el-button @click="specialPriceClose">取 消</el-button>
      <el-button type="primary" @click="specialPriceSave">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'SpecialPrice',
  emits: ['special-price'],
  data() {
    return {
      weekOptions: [
        {
          label: '周日',
          value: 0,
        },
        {
          label: '周一',
          value: 1,
        },
        {
          label: '周二',
          value: 2,
        },
        {
          label: '周三',
          value: 3,
        },
        {
          label: '周四',
          value: 4,
        },
        {
          label: '周五',
          value: 5,
        },
        {
          label: '周六',
          value: 6,
        },
      ],
      specialPriceVisible: false,
      specialForm: {
        datePriceList: [],
        weekPriceList: [],
        sectionList: []
      },
    }
  },
  methods: {
    showEdit(list, weekPriceList, sectionList) {
      this.specialForm.datePriceList = list
      this.specialForm.weekPriceList = weekPriceList
      this.specialForm.sectionList = sectionList
      this.specialPriceVisible = true
    },
    specialPriceClose() {
      this.specialForm = {
        datePriceList: [],
        weekPriceList: [],
        sectionList: []
      }
      this.specialPriceVisible = false
    },
    specialPriceSave() {
      //判断日期是否有重复
      const checkDates = this.checkValid('dates')
      const checkWeeks = this.checkValid('weeks')
      if (checkDates) {
        this.$message.error('存在不符合条件的日期区间，请检查后确认！')
        return
      }
      if (checkWeeks) {
        this.$message.error('存在不符合条件的星期区间，请检查后确认！')
        return
      }
      this.specialForm.datePriceList.sort((a, b) => {
        const res = a.startDate > b.endDate ? -1 : 1
        return res
      })
      this.specialForm.weekPriceList.sort((a, b) => a.startMonth - b.endMonth)
      this.specialForm.datePriceList.sort((a, b) => a.startDate > b.endDate)
      this.$emit('special-price', {
        datePriceList: this.specialForm.datePriceList,
        weekPriceList: this.specialForm.weekPriceList,
      })
      this.specialPriceClose()
    },
    checkValid(type) {
      if (type === 'dates') {
        return this.specialForm.datePriceList.find(
          (item, index) =>
            (item.startDate !== 0 && !item.startDate) ||
            (item.endDate !== 0 && !item.endDate) ||
            item.startDate > item.endDate ||
            (index > 0 &&
              ((item.startDate >=
                this.specialForm.datePriceList[index - 1].startDate &&
                item.startDate <=
                  this.specialForm.datePriceList[index - 1].endDate) ||
                (item.endDate >=
                  this.specialForm.datePriceList[index - 1].startDate &&
                  item.endDate <=
                    this.specialForm.datePriceList[index - 1].endDate)))
        )
      } else {
        return this.specialForm.weekPriceList.find(
          (item, index) =>
            (item.startMonth !== 0 && !item.startMonth) ||
            (item.endMonth !== 0 && !item.endMonth) ||
            item.startMonth > item.endMonth ||
            (index > 0 &&
              ((item.startMonth >=
                this.specialForm.weekPriceList[index - 1].startMonth &&
                item.startMonth <=
                  this.specialForm.weekPriceList[index - 1].endMonth) ||
                (item.endMonth >=
                  this.specialForm.weekPriceList[index - 1].startMonth &&
                  item.endMonth <=
                    this.specialForm.weekPriceList[index - 1].endMonth)))
        )
      }
    },
    addRules(s) {
      if (s === 'dates') {
        this.specialForm.datePriceList.push({
          startDate: '',
          endDate: '',
          price: 0,
        })
      }
      if (s === 'weeks') {
        this.specialForm.weekPriceList.push({
          startMonth: '',
          endMonth: '',
          WeekList: [],
          price: 0,
        })
      }
    },
    minusRules(index, s) {
      if (s === 'dates') {
        this.specialForm.datePriceList.splice(index, 1)
      }
      if (s === 'weeks') {
        this.specialForm.weekPriceList.splice(index, 1)
      }
    },
  },
}
</script>
<style scoped>
.emptyState {
  font-size: 20px;
  text-align: center;
  padding-top: 15px;
  color: #909399;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
}
.el-row {
  margin: 12px 0;
}
</style>
